// Components/FilterBadge.tsx
import React from 'react';
import './FilterBadge.css';
import { Filter } from '../../Models/Filter';

type Props = {
    filter: Filter;
    isActive: boolean;
    onToggle: (filter: Filter) => void;
};

const FilterBadge: React.FC<Props> = ({ filter, isActive, onToggle }) => {
    return (
        <button
            className={`filter-badge ${isActive ? 'active' : ''}`}
            onClick={() => onToggle(filter)}
        >
            {filter.value && filter.value.trim() !== '' ? filter.value : 'non connu'}
            {filter.count > 0 && <span className="count">{filter.count > 99 ? '99+' : filter.count}</span>}
        </button>
    );
};

export default FilterBadge;
